import React from "react";
import "./index.css";

const LoadMoreButton = ({ onClick, isLoading, message }) => {
  return (
    <div className="load-more-btn-wrapper">
      <button className="load-more-btn" onClick={onClick}>
        {isLoading ? "Loading..." : message}
      </button>
    </div>
  );
};

export default LoadMoreButton;



// WEBPACK FOOTER //
// ./src/components/HorizontalSlider/components/LoadMoreButton/index.js